module.exports = __webpack_public_path__ + "static/Salamander-e76388db8fb9f067a265967425c57bcf.jpg";